<template>
  <v-container fluid>
    <v-row shrink dense>
      <v-col cols="2">
        <v-card class="" flat style="height:100%">
          <!-- <v-btn block dark @click="Back()" height="34px" color="black">
            Back
          </v-btn> -->
          <v-img
            class="v-window-item"
            :src="asset.thmUrl"
            contain
            style="position:absolute; top:0; bottom:0px;"
          ></v-img>
        </v-card>
      </v-col>
      <v-col cols="10">
        <v-card class="ma-0 pa-0" min-width="200px">
          <v-container>
            <v-col class="pt-0">
              <v-row>
                <v-card
                  color="primaryDark"
                  width="100%"
                  dark
                  class="subtitle-1"
                >
                  <v-row dense class="">
                    <v-col align-self="center" class="pl-4 pa-0">
                      Asset Details
                    </v-col>
                    <v-col cols="auto" style="padding-bottom: 0px !important">
                      <!-- <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            v-on:click="OnTapDownloadPDF()"
                            width="38px"
                            class="ma-2"
                            :loading="downloadingPDF"
                          >
                            <v-icon size="28" dark v-on="on"
                              >mdi-file-pdf</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Download PDF</span>
                      </v-tooltip> -->
                    </v-col>
                    <v-col
                      cols="auto"
                      style="padding-bottom: 0px !important"
                      v-if="hasClonableSection && hasAvailableTargetMarkets"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            v-on:click="CloneAsset()"
                            width="38px"
                            class="ma-2"
                          >
                            <v-icon size="28" dark v-on="on"
                              >mdi-content-copy</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Clone Asset</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="auto" style="padding-bottom: 0px !important">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            v-on:click="SwitchView()"
                            width="38px"
                            height="38px"
                            class="ma-2"
                          >
                            <v-icon size="24" dark v-on="on">mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Switch to Edit Mode</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card>
              </v-row>
            </v-col>
            <v-col dense style="padding-top: 0px !important">
              <v-row
                class="cardContent title font-weight-medium pa-0 pb-0"
                dense
              >
                <v-col class="pa-0" cols="3" dense>Identifier:</v-col>
                <v-col class="pa-0" dense>{{ asset.identifier }}</v-col>
              </v-row>
              <v-row class="cardContent pa-0 pb-0" dense>
                <v-col class="pa-0" cols="3" dense>Category:</v-col>
                <v-col class="pa-0" dense>{{ asset.categoryName }}</v-col>
              </v-row>
              <v-row class="cardContent pa-0 pb-0" dense>
                <v-col class="pa-0" cols="3" dense>Name:</v-col>
                <v-col class="pa-0" dense>{{ asset.name }}</v-col>
              </v-row>
              <v-row class="cardContent pa-0 pb-0" dense>
                <v-col class="pa-0" cols="3" dense>Description:</v-col>
                <v-col class="pa-0" dense>{{ asset.description }}</v-col>
              </v-row>
              <v-row class="cardContent pa-0 pb-0" dense>
                <v-col class="pa-0" cols="3" dense>Created Date:</v-col>
                <v-col class="pa-0" dense>{{ formatDate(asset.creationDate) }}</v-col>
              </v-row>
              <v-row class="cardContent pa-0 pb-0" dense>
                <v-col class="pa-0" cols="3" dense>Created By:</v-col>
                <v-col class="pa-0" dense>{{ asset.createdBy }}</v-col>
              </v-row>
              <v-row class="cardContent pa-0 pb-0" dense>
                <v-col class="pa-0" cols="3" dense>Modified Date:</v-col>
                <v-col class="pa-0" dense>{{ formatDate(asset.modifiedDate) }}</v-col>
              </v-row>
              <v-row class="cardContent pa-0 pb-0" dense>
                <v-col class="pa-0" cols="3" dense>Modified By:</v-col>
                <v-col class="pa-0" dense>{{ asset.modifiedBy || '-' }}</v-col>
              </v-row>
            </v-col>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <!--
                Then attributes
            -->
    <v-row class="mt-4">
      <!--
                    Resources first, as these are the biggest and most important tiles
                -->
      <v-col cols="12" lg="12" class="pa-3">
        <v-card class="resourceCarouselPanel">
          <v-carousel
            v-if="asset.resources"
            class="resourceCarousel"
            height="450px"
            show-arrows-on-hover
          >
            <v-carousel-item
              v-for="(resource, i) in reorderedResources"
              :key="resource.id || i"
              class="resourceCarouselItem"
            >
              <AssetResourceView
                :resource="resource"
                v-on:ReloadAsset="ReloadAsset()"
              ></AssetResourceView>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-col>

      <!--
                Then attributes
                -->

      <AttributeWidgetTemplate
        :attributeWidgets="attributeWidgets"
      ></AttributeWidgetTemplate>

      <!--
                Then content, if it exists, as we believe this to be more important than attributes
                -->
      <v-col
        cols="12"
        lg="12"
        class="pa-3"
        v-for="(content, index) in asset.contents"
        :key="content.id"
      >
        <asset-detail-content :content="content" :readOnly="true">
        </asset-detail-content>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="12" lg="12" class="pa-3">
        <AssetProfileDataPanel
          :assetId="(asset && asset.assetDetailid) || assetDetailid"
          :readOnly="true"
        ></AssetProfileDataPanel>
      </v-col>
    </v-row>

    <!-- Moved up above for now
            <ResourceWidgetTemplate :resourceWidgets="resourceWidgets"></ResourceWidgetTemplate>
            -->

    <!-- Clone Asset Dialog -->
    <clone-asset-dialog
      :visible.sync="cloneAssetDialog"
      :assetId="asset.assetDetailid"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import AttributeWidgetTemplate from "../../views/assetDetailTemplates/AttributeWidgetTemplate.vue";
import AssetResourceView from "../../views/assetDetail/AssetResourceView.vue";
import AssetDetailContent from "./AssetDetailContent.vue";
import CloneAssetDialog from "./CloneAssetDialog.vue";
import AssetProfileDataPanel from "./AssetProfileDataPanel.vue";

export default {
  name: "AssetDetailView",
  components: {
    AttributeWidgetTemplate,
    AssetResourceView,
    AssetDetailContent,
    CloneAssetDialog,
    AssetProfileDataPanel,
  },
  props: {
    //Asset detail id
    assetDetailid: {
      default: "",
      type: String,
    },
  },
  computed: {
    ...mapState("assetxpstate", ["asset", "section"]),
    ...mapGetters("authentication", ["hasAvailableTargetMarkets"]),
    ...mapGetters("assetxpstate", ["hasClonableSection"]),

    reorderedResources() {
      var res = this.asset.resources;

      if (res && res.length) {
        var glbs = res.filter((r) => r.type == 1);
        var others = res.filter((r) => r.type !== 1);
        return glbs.concat(others);
      }
      return [];
    },
  },
  mounted: function() {},
  data: () => ({
    overlay: false,
    resources: [],
    attributeWidgets: [],
    resourceWidgets: [],
    resourceTypes: [
      { id: 0, name: "Images" },
      { id: 1, name: "3d Objects" },
      { id: 2, name: "Data" },
      { id: 3, name: "Other" },
    ],
    downloadingPDF: false,
    cloneAssetDialog: false,
  }),
  methods: {
    ...mapGetters("authentication", ["CanUserEditAssets"]),
    ...mapActions("assetxpstate", [
      "RemoveAsset",
      "GetAsset",
      "GetSectionById",
      "DownloadPDF",
    ]),
    ...mapActions("navstate", ["GetSelectedSection"]),
    OnTapDownloadPDF() {
      this.downloadingPDF = true;
      this.DownloadPDF(this.asset.assetListingid).then(() => {
        this.downloadingPDF = false;
      });
    },
    GetResourceType(widget) {
      var type = this.resourceTypes.find((t) => t.id == widget.resourceType);
      return type.name;
    },

    SwitchView() {
      this.$emit("switchAssetDetailView");
    },
    ReloadAsset() {
      this.$emit("ReloadAsset");
    },
    HandleFunctionCall(functionName) {
      this[functionName]();
    },
    Back() {
      this.$router.go(-1);
    },
    CloneAsset() {
      this.cloneAssetDialog = true;
    },
    formatDate(isoString) {
      if (!isoString) return '-';
      const date = new Date(isoString);
      if (isNaN(date.getTime())) return '-';
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      const dd = String(date.getDate()).padStart(2, '0');
      const mmm = months[date.getMonth()];
      const yyyy = date.getFullYear();
      const hh = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      return `${dd}.${mmm}.${yyyy} ${hh}:${min}`;
    },
  },
  watch: {
    asset: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.widgets) {
          this.$data.attributeWidgets = newVal.widgets.filter(
            (e) => e.widgetType == 0
          );
        } else {
          this.$data.attributeWidgets = [];
        }
      },
    },
  },
};
</script>

<style scoped>
.v-btn {
  width: 30px;
  height: 30px;
  margin: 0px;
  padding: 0px;
}
.cardContent {
  margin: 0px;
  padding: 5px;
}
.resourceCarouselPanel {
  height: 450px;
  overflow: hidden;
}
.resourceCarousel {
  height: 100%;
  overflow: hidden;
}

.resourceCarouselItem {
  overflow: hidden;
}

.resourceCarousel :deep(.v-window),
.resourceCarousel :deep(.v-window__container),
.resourceCarousel :deep(.v-carousel__item),
.resourceCarousel :deep(.v-window-item),
.resourceCarousel :deep(.v-window-item__container) {
  height: 100% !important;
  max-height: 100% !important;
  overflow: hidden !important;
}
</style>
